module.exports = __webpack_public_path__ + "media/images/v2/Background-932175fd3482e12741fe6a21a10b85a3.png";